import React from 'react';
import { Alert } from './Alert';

/**
 * Notification Container - Manages multiple toast notifications
 * Used in:
 *   - App.js for global notification management
 *   - Displays notifications from useUIStore
 */
export const ToastContainer = ({ toasts = [], onClose }) => {
  if (!toasts.length) return null;

  return (
    <div
      className={`
        fixed z-50 space-y-2
        top-2 left-2 right-2 px-2    /* mobile: full width with padding */
        sm:top-4 sm:right-4 sm:left-auto sm:px-0  /* tablet/desktop: top-right corner */
        w-auto
        max-w-full sm:max-w-sm md:max-w-md lg:max-w-sm
      `}
    >
      {toasts.map((toast) => (
        <Alert
          key={toast.id}
          type={toast.type}
          title={toast.title}
          message={toast.message}
          onClose={() => onClose(toast.id)}
          show={true}
        />
      ))}
    </div>
  );
   
};
